import { defineMessages } from 'react-intl';

// these are i18n strings that are common to both the editor and live pages ellipsis dropdowns
export const i18n = defineMessages({
	viewChanges: {
		id: 'editor-ellipsis-dropdown.open.ellipsis.view.changes',
		description: 'The label of View changes button inside ellipsis dropdown of the editor',
		defaultMessage: 'View changes',
	},
	resolvedComments: {
		id: 'editor-ellipsis-dropdown.open.ellipsis.resolved.comments',
		description: 'The label of Resolved comments button inside ellipsis dropdown of the editor',
		defaultMessage: 'Resolved comments',
	},
	templateImportDocs: {
		id: 'editor-ellipsis-dropdown.ellipsis.open.ellipsis.templates.and.import',
		description:
			'The label of Templates & import doc button inside ellipsis dropdown of the editor',
		defaultMessage: 'Templates & import doc',
	},
	more: {
		id: 'editor-ellipsis-dropdown.open.ellipsis.more',
		description: 'The text is shown as an accessible label for the More (ellipsis) icon button in the editor toolbar drop-down, used by screen readers to describe the button that opens a menu of additional editor actions.',
		defaultMessage: 'More',
	},
});
